import Marquee from "react-fast-marquee";

const ITEMS = [
  "Business & Economics",
  "Geopolitics",
  "Science & Engineering",
  "Technology & AI",
  "Education & History",
  "Society & Culture",
  "Space & Energy",
];

export const EditorialMarquee = () => (
  <div className="border-y border-black/10 py-8 md:py-10 overflow-hidden" data-testid="editorial-marquee">
    <Marquee speed={28} gradient={false} pauseOnHover>
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="font-serif text-3xl md:text-5xl tracking-tight whitespace-nowrap px-8 text-ink">
            {item}
          </span>
          <span className="h-2 w-2 rotate-45 bg-mutedblue/60" aria-hidden="true" />
        </span>
      ))}
    </Marquee>
  </div>
);
